import { Component, inject, signal } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormControlAutocompleteComponent } from '@components/form-control/autocomplete/autocomplete.component';
import { environment } from '@environment';
import { searchResource, User, UserListResponse } from '@models';

@Component({
  selector: 'app-role-user-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
  imports: [
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatButtonModule,
    FormControlAutocompleteComponent,
  ],
})
export class RoleUserFormComponent {
  dialogRef = inject<MatDialogRef<RoleUserFormComponent>>(MatDialogRef);

  userDisplayWith = (u: User) => u.email;
  userSearch = signal('');
  userResource = searchResource<User[]>(
    () => this.userSearch().length > 2 ? `${environment.komainuHost}/account/?q=${this.userSearch()}` : null,
    500,
    {
      parse: (value: unknown) => (value as UserListResponse).accounts
    }
  );

  form = new FormGroup({
    user: new FormControl(null, {
      nonNullable: true,
      validators: [Validators.required],
    }),
  });

  save() {
    if (this.form.pristine || !this.form.valid) {
      return;
    }

    this.dialogRef.close(this.form.value.user)
  }
}
